import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getObligationFormConfig = () => {
  return {
    Title: {
      fieldId: 'Title',
      formLabel: t('obligations.fields.Title'),
      columnHeader: t('obligations.columns.Title'),
      allowAsConditionSource: true,
    },
    Type: {
      fieldId: 'Type',
      formLabel: t('obligations.fields.Type'),
      columnHeader: t('obligations.columns.Type'),
      allowAsConditionSource: true,
      displayType: {
        displayType: 'commonLookup',
        i18nKey: 'obligations.fields.types',
      },
    },
    ParentId: {
      fieldId: 'ParentId',
      formLabel: t('obligations.fields.ParentId'),
      columnHeader: t('obligations.columns.ParentTitle'),
      // Read-only: an obligation type decides whether a parent is meaningful.
      defaultConditions: {
        readOnly: true,
        rules: [{ ifField: 'Type', values: ['chapter', 'rule', 'task'] }],
      },
    },
    Description: {
      fieldId: 'Description',
      formLabel: t('obligations.fields.Description'),
      columnHeader: t('obligations.columns.Description'),
      displayType: { displayType: 'textarea' },
      // Not gated by `defaultConditions`: a hidden field is nulled in the save
      // payload, and this one is a non-nullable `z.string()` in the write schema.
    },
    Interpretation: {
      fieldId: 'Interpretation',
      formLabel: t('obligations.fields.Interpretation'),
      columnHeader: t('obligations.columns.Interpretation'),
      allowTargetConditions: true,
      displayType: { displayType: 'textarea' },
    },
    Adherence: {
      fieldId: 'Adherence',
      formLabel: t('obligations.fields.Adherence'),
      columnHeader: t('obligations.columns.Adherence'),
      allowAsConditionSource: true,
      displayType: { displayType: 'rating', ratingKey: 'adherence' },
    },
    Owners: {
      fieldId: 'Owners',
      formLabel: t('fields.Owner'),
      columnHeader: t('columns.owners'),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
    },
    Contributors: {
      fieldId: 'Contributors',
      formLabel: t('fields.Contributor'),
      columnHeader: t('columns.contributors'),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    Viewers: {
      fieldId: 'Viewers',
      formLabel: t(`fields.Viewer`),
      columnHeader: t(`columns.viewers`),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    tags: {
      fieldId: 'tags',
      formLabel: t('fields.Tags'),
      columnHeader: t('columns.tags'),
      displayType: {
        displayType: 'tags',
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    departments: {
      fieldId: 'departments',
      formLabel: t('fields.Departments'),
      columnHeader: t('columns.departments'),
      displayType: {
        displayType: 'departments',
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
  } as const satisfies FormConfig;
};
